const cityArray = [
  "",
  //1
  "تهران",
  "اصفهان",
  "ارومیه",
  "اراک",
  //5
  "اهواز",
  "تبریز",
  "بندرعباس",
  "شیراز",
  "کرج",
  // 10
  "قزوین",
  "قم",
  "زاهدان",
  "مشهد",
  "یزد",
  // 15
  "بجنورد",
  "رشت",
  "ساری",
  "گرگان",
  "کرمان",
  // 20
  "بوشهر",
  "کرمانشاه",
  "سنندج",
  "مهاباد",
  "همدان",
  // 25
  "زنجان",
  "اردبیل",
  "سمنان",
  "",
  "ایلام",
  // 30
  "خرم آباد",
  "شهرکرد",
  "یاسوج",
];

export { cityArray };
